import { render } from "./PatientDME.vue?vue&type=template&id=549da372&ts=true"
import script from "./PatientDME.ts?vue&type=script&lang=ts&external"
export * from "./PatientDME.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__